// Copyright (c) 2024. Sendanor <info@sendanor.fi>. All rights reserved.

import {
    Fragment,
    ReactNode,
} from "react";
import {
    useLocation,
} from "react-router-dom";
import { ScrollToHere } from "../../../../../../io/hyperify/frontend/components/common/scrollToHere/ScrollToHere";
import {
    SEO,
    SEOProps,
} from "./SEO";

export interface SEOFragmentProps extends SEOProps {
    /**
     * The route path
     */
    readonly path : string;
    readonly children ?: ReactNode;
}

export function SEOFragment ( props: SEOFragmentProps ) {
    const path = props.path;
    const children = props.children;
    const location = useLocation();
    const currentPath = location.pathname;
    return (
        <Fragment>
            { currentPath === path ? (
                <>
                    <SEO { ...props } />
                    <ScrollToHere path={ path } />
                </>
            ) : null }
            {children}
        </Fragment>
    );
}
